import React from 'react';
import { useHistory } from 'react-router-dom';

import css from './DropdownItem.css';
import { IconHighlightL, IconSearchL } from '../../../../icons';
import classNames from 'classnames';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

const DropdownItem = ({ children, name, hash = '', searchParams = {}, externalUrl }) => {
    const history = useHistory();

    const navigate = () => {
        if (externalUrl) {
            return window.open(externalUrl, '_blank', 'noopener,noreferrer');
        }

        history.push(
            createResourceLocatorString(
                name,
                routeConfiguration(),
                {},
                { ...(searchParams || {}) },
                hash
            )
        );
    };

    return (
        <div onClick={navigate} className={css.root}>
            {children}
        </div>
    );
};

const Icon = ({ children }) => <div className={css.iconHolder}>{children || <IconSearchL />}</div>;
const Heading = ({ children }) => <p className={css.heading}>{children}</p>;
const Description = ({ children, highlight }) => (
    <p
        className={classNames(css.description, {
            [css.highlight]: !!highlight,
        })}
    >
        {highlight && <IconHighlightL />}
        {children}
    </p>
);
const Content = ({ children }) => <div className={css.content}>{children}</div>;

DropdownItem.Icon = Icon;
DropdownItem.Heading = Heading;
DropdownItem.Description = Description;
DropdownItem.Content = Content;

export default DropdownItem;
